var _circle, _circle2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera90(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 44,
    stroke: "#E7B178",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 44,
    stroke: "#E7B178",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.001 44.9999C79.001 64.5013 63.7459 80.2499 45.001 80.2499C26.2561 80.2499 11.001 64.5013 11.001 44.9999C11.001 25.4985 26.2561 9.74994 45.001 9.74994C63.7459 9.74994 79.001 25.4985 79.001 44.9999Z",
    fill: "#E8ECF0",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.25 45.9559C56.25 49.2059 53.325 51.6912 49.5 51.6912C45.675 51.6912 42.75 49.2059 42.75 45.9559C42.75 42.7059 45.675 40.2206 49.5 40.2206C53.325 40.2206 56.25 42.7059 56.25 45.9559ZM67.5 36.3971V57.4265C67.5 59.5294 65.475 61.25 63 61.25H27C24.525 61.25 22.5 59.5294 22.5 57.4265V36.3971C22.5 34.2941 24.525 32.5735 27 32.5735V30.6618H36V32.5735H40.5L42.75 28.75H56.25L58.5 32.5735H63C65.475 32.5735 67.5 34.2941 67.5 36.3971ZM34.875 40.2206C34.875 38.6912 33.3 37.3529 31.5 37.3529C29.7 37.3529 28.125 38.6912 28.125 40.2206C28.125 41.75 29.7 43.0882 31.5 43.0882C33.3 43.0882 34.875 41.75 34.875 40.2206ZM60.75 45.9559C60.75 40.6029 55.8 36.3971 49.5 36.3971C43.2 36.3971 38.25 40.6029 38.25 45.9559C38.25 51.3088 43.2 55.5147 49.5 55.5147C55.8 55.5147 60.75 51.3088 60.75 45.9559Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera90);
export default __webpack_public_path__ + "static/media/camera90.7965e263f2c939f64d8dd8b50ec06a26.svg";
export { ForwardRef as ReactComponent };